var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "md-layout md-gutter md-alignment-top-center" },
        [
          _vm.loading || !_vm.businessmodel
            ? _c(
                "div",
                { staticClass: "loading" },
                [
                  _c("md-progress-spinner", {
                    attrs: {
                      "md-diameter": 50,
                      "md-stroke": 5,
                      "md-mode": "indeterminate"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.businessmodel && !_vm.loading
        ? _c(
            "div",
            {
              staticClass: "md-layout md-gutter md-alignment-top-center",
              staticStyle: { "margin-bottom": "20px" }
            },
            [
              _c("div", { staticClass: "md-layout-item md-size-100" }, [
                _c(
                  "div",
                  {
                    staticClass: "md-layout md-gutter md-alignment-top-center"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-size-10 md-medium-size-20"
                      },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "Brick",
                                params: {
                                  hash: _vm.hash,
                                  name: "Kundensegment"
                                }
                              }
                            }
                          },
                          [
                            _c(
                              "md-card",
                              {
                                class: {
                                  "md-primary": _vm.isDone("Kundensegment")
                                },
                                attrs: { "md-with-hover": "" }
                              },
                              [
                                _c(
                                  "md-card-content",
                                  { staticClass: "status-bricks" },
                                  [_vm._v("Kunden segment\n              ")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-size-10 md-medium-size-20"
                      },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "Brick",
                                params: { hash: _vm.hash, name: "Wertangebot" }
                              }
                            }
                          },
                          [
                            _c(
                              "md-card",
                              {
                                class: {
                                  "md-primary": _vm.isDone("Wertangebot")
                                },
                                attrs: { "md-with-hover": "" }
                              },
                              [
                                _c(
                                  "md-card-content",
                                  { staticClass: "status-bricks" },
                                  [_vm._v("Wertangebot\n              ")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-size-10 md-medium-size-20"
                      },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "Brick",
                                params: { hash: _vm.hash, name: "Kanäle" }
                              }
                            }
                          },
                          [
                            _c(
                              "md-card",
                              {
                                class: { "md-primary": _vm.isDone("Kanäle") },
                                attrs: { "md-with-hover": "" }
                              },
                              [
                                _c(
                                  "md-card-content",
                                  { staticClass: "status-bricks" },
                                  [_vm._v("Kanäle ")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-size-10 md-medium-size-20"
                      },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "Brick",
                                params: {
                                  hash: _vm.hash,
                                  name: "Kundenbeziehung"
                                }
                              }
                            }
                          },
                          [
                            _c(
                              "md-card",
                              {
                                class: {
                                  "md-primary": _vm.isDone("Kundenbeziehung")
                                },
                                attrs: { "md-with-hover": "" }
                              },
                              [
                                _c(
                                  "md-card-content",
                                  { staticClass: "status-bricks" },
                                  [_vm._v("Kunden beziehung\n              ")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-size-10 md-medium-size-20"
                      },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "Brick",
                                params: {
                                  hash: _vm.hash,
                                  name: "Einnahmequellen"
                                }
                              }
                            }
                          },
                          [
                            _c(
                              "md-card",
                              {
                                class: {
                                  "md-primary": _vm.isDone("Einnahmequellen")
                                },
                                attrs: { "md-with-hover": "" }
                              },
                              [
                                _c(
                                  "md-card-content",
                                  { staticClass: "status-bricks" },
                                  [_vm._v("Einnahme quellen\n              ")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-size-10 md-medium-size-20"
                      },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "Brick",
                                params: {
                                  hash: _vm.hash,
                                  name: "Schlüsselressourcen"
                                }
                              }
                            }
                          },
                          [
                            _c(
                              "md-card",
                              {
                                class: {
                                  "md-primary": _vm.isDone(
                                    "Schlüsselressourcen"
                                  )
                                },
                                attrs: { "md-with-hover": "" }
                              },
                              [
                                _c(
                                  "md-card-content",
                                  { staticClass: "status-bricks" },
                                  [
                                    _vm._v(
                                      "Schlüssel ressourcen\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-size-10 md-medium-size-20"
                      },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "Brick",
                                params: {
                                  hash: _vm.hash,
                                  name: "Schlüsselaktivitäten"
                                }
                              }
                            }
                          },
                          [
                            _c(
                              "md-card",
                              {
                                class: {
                                  "md-primary": _vm.isDone(
                                    "Schlüsselaktivitäten"
                                  )
                                },
                                attrs: { "md-with-hover": "" }
                              },
                              [
                                _c(
                                  "md-card-content",
                                  { staticClass: "status-bricks" },
                                  [
                                    _vm._v(
                                      "Schlüssel aktivitäten\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-size-10 md-medium-size-20"
                      },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "Brick",
                                params: {
                                  hash: _vm.hash,
                                  name: "Schlüsselpartnerschaften"
                                }
                              }
                            }
                          },
                          [
                            _c(
                              "md-card",
                              {
                                class: {
                                  "md-primary": _vm.isDone(
                                    "Schlüsselpartnerschaften"
                                  )
                                },
                                attrs: { "md-with-hover": "" }
                              },
                              [
                                _c(
                                  "md-card-content",
                                  { staticClass: "status-bricks" },
                                  [
                                    _vm._v(
                                      "Schlüsselpart nerschaften\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-size-10 md-medium-size-20"
                      },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "Brick",
                                params: {
                                  hash: _vm.hash,
                                  name: "Kostenstruktur"
                                }
                              }
                            }
                          },
                          [
                            _c(
                              "md-card",
                              {
                                class: {
                                  "md-primary": _vm.isDone("Kostenstruktur")
                                },
                                attrs: { "md-with-hover": "" }
                              },
                              [
                                _c(
                                  "md-card-content",
                                  { staticClass: "status-bricks" },
                                  [_vm._v("Kosten struktur\n              ")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.brick && _vm.questionsequences
        ? _c(
            "div",
            { staticClass: "md-layout md-gutter md-alignment-top-center" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "md-layout-item md-size-15 md-medium-size-10 md-small-size-15"
                },
                [
                  _vm.brick.donewithquestions
                    ? _c(
                        "md-button",
                        {
                          staticClass: "md-fixed md-fab md-raised md-accent",
                          staticStyle: {
                            "margin-right": "20px",
                            height: "60px"
                          },
                          on: {
                            click: function($event) {
                              _vm.updateBrickToOverview()
                              _vm.goBack()
                            }
                          }
                        },
                        [_c("md-icon", [_vm._v("arrow_back")])],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.brick.donewithquestions
                    ? _c(
                        "md-button",
                        {
                          staticClass: "md-raised md-accent",
                          staticStyle: {
                            "margin-right": "20px",
                            height: "60px"
                          },
                          on: {
                            click: function($event) {
                              return _vm.goBack()
                            }
                          }
                        },
                        [
                          _vm._v("\n        Später fortfahren"),
                          _c("br"),
                          _vm._v("und zur Übersicht\n      ")
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "md-layout-item md-size-70 md-medium-size-70 md-small-size-100 md-xsmall-size-100"
                },
                [
                  _c(
                    "md-card",
                    { staticStyle: { width: "100%", "min-height": "600px" } },
                    [
                      !_vm.loading && _vm.brick.donewithquestions
                        ? _c(
                            "div",
                            [
                              _c("md-card-header", [
                                _c("div", { staticClass: "md-title" }, [
                                  _vm._v(_vm._s(_vm.name))
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "md-content",
                                { staticClass: "md-secondary" },
                                [
                                  _c(
                                    "md-card-header",
                                    [
                                      _c(
                                        "md-card-header-text",
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "md-subhead" },
                                            [
                                              _vm._v(
                                                "\n                  Sie haben die grundlegenden Fragen zu diesem Baustein\n                  beantwortet. Hier können Sie diesen Geschäftsmodellbaustein\n                  erweitern. Alternativ können Sie die Fragen zu diesem\n                  Baustein erneut beantworten.\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-button",
                                            {
                                              staticClass: "md-primary",
                                              on: {
                                                click: function($event) {
                                                  return _vm.updateBrickSetNotDone()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "Fragen erneut beantworten"
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("md-divider", {
                                staticStyle: {
                                  "margin-top": "10px",
                                  "margin-bottom": "10px"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "md-button",
                                {
                                  staticClass: "md-fab md-primary md-mini",
                                  on: {
                                    click: function($event) {
                                      _vm.currentaspect = _vm.brick
                                      _vm.aspecttoadd.brick = true
                                      _vm.customAdd = true
                                    }
                                  }
                                },
                                [_c("md-icon", [_vm._v("add")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout md-gutter md-alignment-top-center"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-size-90 md-small-size-100 md-xsmall-size-100"
                                    },
                                    _vm._l(_vm.brick.elementinstances, function(
                                      element
                                    ) {
                                      return _c(
                                        "div",
                                        { key: element.hash },
                                        [
                                          _c(
                                            "md-card",
                                            {
                                              staticClass:
                                                "md-primary margin-twenty"
                                            },
                                            [
                                              _c(
                                                "md-card-header",
                                                [
                                                  _c("md-card-header-text", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "md-title"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(element.name)
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-button",
                                                {
                                                  staticClass:
                                                    "md-fab md-accent md-mini",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.currentaspect = element
                                                      _vm.aspecttoadd.brick = false
                                                      _vm.customAdd = true
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("md-icon", [_vm._v("add")])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-card-content",
                                                _vm._l(
                                                  element.children,
                                                  function(child) {
                                                    return _c(
                                                      "div",
                                                      { key: child.hash },
                                                      [
                                                        _c(
                                                          "md-card",
                                                          {
                                                            staticClass:
                                                              "md-secondary margin-twenty"
                                                          },
                                                          [
                                                            _c(
                                                              "md-card-header",
                                                              [
                                                                _c(
                                                                  "md-card-header-text",
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "md-title"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            child.name
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "md-card-content",
                                                              [
                                                                _vm._l(
                                                                  child.children,
                                                                  function(
                                                                    childchild
                                                                  ) {
                                                                    return _c(
                                                                      "div",
                                                                      {
                                                                        key:
                                                                          childchild.description
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "md-card",
                                                                          {
                                                                            staticClass:
                                                                              "md-secondary margin-twenty"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "md-card-content",
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "md-layout md-gutter md-alignment-top-center"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "md-layout-item md-size-90 md-medium-size-70 md-small-size-100 md-xsmall-size-100"
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "md-field",
                                                                                          [
                                                                                            _c(
                                                                                              "label",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "Bitte benennen Sie den Aspekt"
                                                                                                )
                                                                                              ]
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " "
                                                                                            ),
                                                                                            _c(
                                                                                              "md-input",
                                                                                              {
                                                                                                attrs: {
                                                                                                  maxlength:
                                                                                                    "100"
                                                                                                },
                                                                                                model: {
                                                                                                  value:
                                                                                                    childchild.name,
                                                                                                  callback: function(
                                                                                                    $$v
                                                                                                  ) {
                                                                                                    _vm.$set(
                                                                                                      childchild,
                                                                                                      "name",
                                                                                                      $$v
                                                                                                    )
                                                                                                  },
                                                                                                  expression:
                                                                                                    "childchild.name"
                                                                                                }
                                                                                              }
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "md-layout-item md-size-10 md-medium-size-30 md-small-size-100 md-xsmall-size-100"
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "md-button",
                                                                                          {
                                                                                            staticClass:
                                                                                              "md-fab md-mini md-plain",
                                                                                            on: {
                                                                                              click: function(
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.removeElement(
                                                                                                  child,
                                                                                                  childchild.description
                                                                                                )
                                                                                              }
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "md-icon",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "delete"
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "md-button",
                                                                  {
                                                                    staticClass:
                                                                      "md-raised md-primary",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.addElement(
                                                                          child
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Aspekt hinzufügen"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              2
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "md-card-actions",
                                                              [
                                                                _c(
                                                                  "md-button",
                                                                  {
                                                                    staticClass:
                                                                      "md-raised md-primary md-icon-button",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.removeChildAspect(
                                                                          element,
                                                                          child
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "md-icon",
                                                                      [
                                                                        _vm._v(
                                                                          "delete"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-card-actions",
                                                [
                                                  _c(
                                                    "md-button",
                                                    {
                                                      staticClass:
                                                        "md-icon-button",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.removeAspect(
                                                            element
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("md-icon", [
                                                        _vm._v("delete")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.brick.donewithquestions
                        ? _c(
                            "div",
                            [
                              _c("md-card-header", [
                                _c("div", { staticClass: "md-title" }, [
                                  _vm._v(_vm._s(_vm.name))
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "md-card-content",
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("small", [_vm._v("Fortschritt")]),
                                      _c("md-progress-bar", {
                                        attrs: {
                                          "md-mode": "determinate",
                                          "md-value": _vm.amount()
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("h3", [
                                    _vm._v(_vm._s(_vm.currentquestion.text))
                                  ]),
                                  _vm._v(" "),
                                  _vm.currentquestion.type == "multiple"
                                    ? _c("h5", [
                                        _vm._v(
                                          "\n              Mehrfachauswahl möglich\n            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.currentquestion.helpertext) +
                                      "\n            "
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout md-gutter md-alignment-top-center"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "md-layout-item md-size-70 md-medium-size-70 md-small-size-100 md-xsmall-size-100"
                                        },
                                        [
                                          _c(
                                            "form",
                                            { attrs: { nonvalidate: "" } },
                                            [
                                              _c(
                                                "md-field",
                                                [
                                                  _c(
                                                    "md-select",
                                                    {
                                                      attrs: {
                                                        id:
                                                          "select" +
                                                          _vm.currentquestion
                                                            .id,
                                                        "md-selected": _vm.checkBounds(
                                                          _vm.currentquestion
                                                            .chosen,
                                                          _vm.currentquestion
                                                            .type
                                                        ),
                                                        multiple: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.currentquestion
                                                            .chosen,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.currentquestion,
                                                            "chosen",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "currentquestion.chosen"
                                                      }
                                                    },
                                                    _vm._l(
                                                      _vm.currentquestion
                                                        .answers,
                                                      function(answer) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: answer.hash,
                                                            on: {
                                                              mouseout: function(
                                                                $event
                                                              ) {
                                                                _vm.currenttext =
                                                                  ""
                                                                _vm.currenthelp =
                                                                  ""
                                                              },
                                                              mouseover: function(
                                                                $event
                                                              ) {
                                                                _vm.currenttext =
                                                                  answer.helpertext
                                                                _vm.currenthelp =
                                                                  answer.bma
                                                              }
                                                            }
                                                          },
                                                          [
                                                            answer.bma &&
                                                            answer.bma != ""
                                                              ? _c(
                                                                  "md-option",
                                                                  {
                                                                    attrs: {
                                                                      value: _vm.stringifyAns(
                                                                        answer
                                                                      )
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        answer.bma
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.chosenIncludesOther()
                                                ? _c(
                                                    "div",
                                                    [
                                                      _vm._l(
                                                        _vm.currentquestion
                                                          .other,
                                                        function(item) {
                                                          return _c(
                                                            "div",
                                                            { key: item.idx },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "md-layout md-gutter md-alignment-top-center"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "md-layout-item md-size-90 md-medium-size-70 md-small-size-100 md-xsmall-size-100"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "md-field",
                                                                        [
                                                                          _c(
                                                                            "label",
                                                                            [
                                                                              _vm._v(
                                                                                "Bitte spezifizieren Sie den Aspekt"
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "md-input",
                                                                            {
                                                                              attrs: {
                                                                                maxlength:
                                                                                  "100"
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  item.text,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    item,
                                                                                    "text",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "item.text"
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "md-layout-item md-size-10 md-medium-size-30 md-small-size-100 md-xsmall-size-100"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "md-button",
                                                                        {
                                                                          staticClass:
                                                                            "md-fab md-mini md-plain",
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.removeFromOther(
                                                                                item.idx
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "md-icon",
                                                                            [
                                                                              _vm._v(
                                                                                "delete"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "md-button",
                                                        {
                                                          staticClass:
                                                            "md-raised md-primary",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.addToOther()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Aspekt hinzufügen"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-layout md-gutter md-alignment-bottom-right"
                                                },
                                                [
                                                  _vm.currentquestion.chosen
                                                    .length > 0 &&
                                                  ((_vm.chosenIncludesOther() &&
                                                    _vm.otherNotEmpty()) ||
                                                    !_vm.chosenIncludesOther())
                                                    ? _c(
                                                        "md-button",
                                                        {
                                                          staticClass:
                                                            "md-raised md-primary",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.setDone()
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("Weiter")]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.seqidx > 0
                                                ? _c(
                                                    "md-button",
                                                    {
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.setBack()
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("Zurück")]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "md-layout-item md-size-30 md-medium-size-30 md-small-size-0 md-xsmall-size-0"
                                        },
                                        [
                                          _vm.currenthelp != "" &&
                                          _vm.currenttext != ""
                                            ? _c("md-content", [
                                                _c("h4", [
                                                  _vm._v(
                                                    _vm._s(_vm.currenthelp)
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(_vm.currenttext)
                                                  )
                                                ])
                                              ])
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.saving
                                    ? _c("md-progress-spinner", {
                                        staticClass: "md-accent",
                                        attrs: { "md-mode": "indeterminate" }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "md-layout-item md-size-15 md-medium-size-20 md-small-size-20 md-xsmall-size-40"
                },
                [
                  _c("small", [
                    _c("img", {
                      staticStyle: { width: "100%", "min-height": "75px" },
                      attrs: { src: _vm.icon }
                    }),
                    _vm._v("Aktuelle\n        Position im Canvas")
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          attrs: { "md-active": _vm.customAdd },
          on: {
            "update:mdActive": function($event) {
              _vm.customAdd = $event
            },
            "update:md-active": function($event) {
              _vm.customAdd = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "10px" } },
            [
              _c("md-dialog-title", [
                _c("strong", [_vm._v("Neuen Aspekt erstellen")])
              ]),
              _vm._v(" "),
              _c(
                "md-field",
                [
                  _c("label", [_vm._v("Bitte benennen Sie den Aspekt")]),
                  _vm._v(" "),
                  _c("md-input", {
                    attrs: { maxlength: "100" },
                    model: {
                      value: _vm.aspecttoadd.name,
                      callback: function($$v) {
                        _vm.$set(_vm.aspecttoadd, "name", $$v)
                      },
                      expression: "aspecttoadd.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-dialog-actions",
                [
                  _vm.aspecttoadd.name != ""
                    ? _c(
                        "md-button",
                        {
                          staticClass: "md-primary",
                          on: {
                            click: function($event) {
                              _vm.addToElementInstances()
                              _vm.customAdd = false
                            }
                          }
                        },
                        [_vm._v("Speichern")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e310e570", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e310e570","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/businessmodel/tile/Brick.vue
// module id = null
// module chunks = 